import { OfferOverviewContainer } from "./offerOverviewContainer/OfferOverviewContainer"
import { SaleAndDeliveryContainer } from "./saleAndDeliveryContainer/SaleAndDeliveryContainer"

export const SalesActivityContainer = () => (
	<>
		<SaleAndDeliveryContainer />
		<OfferOverviewContainer />
	</>
)
